export const transformWebinarCustomText = (text) => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

  const outputString = text.replace(
    urlRegex,
    '<a href="$1" target="_blank" style="position:static" onclick="event.stopPropagation();">$1</a>'
  );

  return outputString;
};



// WEBPACK FOOTER //
// ./src/utils/webinar-custom-text.js